import * as types from '../constants/actionTypes';
const initialState = {
	blogList: [],
	blogDetails: {},
	blogData: {},
	allBlogList: [],
	blogDetailData: {},
	allMarketingBlogList: [],
};

export default function timer(state = [], action) {
	switch (action.type) {
		case types.GET_SPECIALIST_BLOG_LIST:
			return Object.assign({}, state, { blogList: action.blogList });
		case types.ADD_SPECIALIST_BLOG:
			return Object.assign({}, state, { blogDetails: action.blogDetails });
		case types.GET_SPECIALIST_BLOG_BY_ID:
			return Object.assign({}, state, { blogData: action.blogData });
		case types.GET_ALL_BLOG_LIST:
			return Object.assign({}, state, { allBlogList: action.allBlogList });
		case types.LIKE_AND_UNLIKE_BLOG:
			return Object.assign({}, state, { allBlogList: action.allBlogList });
		case types.FAVOUITE_AND_UNFAVOUITE_BLOG:
			return Object.assign({}, state, { allBlogList: action.allBlogList });
		case types.GET_BLOG_DETAILS_BY_ID:
			return Object.assign({}, state, { blogDetailData: action.blogDetailData });
		case types.GET_MARKETING_ALL_BLOG_LIST:
			return Object.assign({}, state, { allMarketingBlogList: action.allMarketingBlogList });
		case types.GET_MARKETING_BLOG_DETAILS_BY_ID:
			return Object.assign({}, state, { marketingBlogDetailData: action.marketingBlogDetailData });

		default:
			return initialState;
	}
}

